import { ElementType } from 'react';
import { LinkParams, FullscreenPreviewState } from '../types';

export const TOGGLE_CHAT = 'BEHAVIOR/TOGGLE_CHAT';
export const TOGGLE_INPUT_DISABLED = 'BEHAVIOR/TOGGLE_INPUT_DISABLED';
export const TOGGLE_SEND_DISABLED = 'BEHAVIOR/TOGGLE_SEND_DISABLED';
export const TOGGLE_MESSAGE_LOADER = 'BEHAVIOR/TOGGLE_MSG_LOADER';
export const SET_BADGE_COUNT = 'BEHAVIOR/SET_BADGE_COUNT';
export const SET_WIDGET_CONFIG = 'SET_WIDGET_CONFIG';
export const SET_LOADING_MESSAGES = 'SET_LOADING_MESSAGES';
export const SET_IS_CHAT_FULL_SCREEN = 'SET_IS_CHAT_FULL_SCREEN';
export const SET_SESSION_AVAILABLE = 'SET_SESSION_AVAILABLE';
export const SET_SESSION_STARTED = 'SET_SESSION_STARTED';
export const SET_SHOW_SENDER_COMPONENT = 'SET_SHOW_SENDER_COMPONENT';
export const SET_RECENT_MESSAGE = 'SET_RECENT_MESSAGE';
export const SET_TOTAL_MESSAGE_COUNT = 'MESSAGES/SET_TOTAL_MESSAGE_COUNT';
export const ADD_NEW_USER_MESSAGE = 'MESSAGES/ADD_NEW_USER_MESSAGE';
export const ADD_NEW_RESPONSE_MESSAGE = 'MESSAGES/ADD_NEW_RESPONSE_MESSAGE';
export const ADD_NEW_LINK_SNIPPET = 'MESSAGES/ADD_NEW_LINK_SNIPPET';
export const ADD_COMPONENT_MESSAGE = 'MESSAGES/ADD_COMPONENT_MESSAGE';
export const DROP_MESSAGES = 'MESSAGES/DROP_MESSAGES';
export const HIDE_AVATAR = 'MESSAGES/HIDE_AVATAR';
export const DELETE_MESSAGES = 'MESSAGES/DELETE_MESSAGES';
export const DELETE_LAST_MESSAGE = 'MESSAGES/DELETE_LAST_MESSAGE';
export const MARK_ALL_READ = 'MESSAGES/MARK_ALL_READ';
export const SET_QUICK_BUTTONS = 'SET_QUICK_BUTTONS';
export const OPEN_FULLSCREEN_PREVIEW = 'FULLSCREEN/OPEN_PREVIEW';
export const CLOSE_FULLSCREEN_PREVIEW = 'FULLSCREEN/CLOSE_PREVIEW';
export const ADD_HISTORY_COMPONENT = 'MESSAGES/ADD_HISTORY_COMPONENT';
export const ADD_HISTORY_MESSAGE = 'MESSAGES/ADD_HISTORY_MESSAGE';
export const RESET_MESSAGES = 'RESET_MESSAGES';
export function ToggleChat() {
  return {
    type: TOGGLE_CHAT,
  };
}

export function ToggleInputDisabled() {
  return {
    type: TOGGLE_INPUT_DISABLED,
  };
}

export function ToggleSendDisabled(cond) {
  return {
    type: TOGGLE_SEND_DISABLED,
    cond,
  };
}

export function SetWidgetConfig(data) {
  return {
    type: SET_WIDGET_CONFIG,
    data,
  };
}

export function SetLoadingMessages(cond) {
  return {
    type: SET_LOADING_MESSAGES,
    cond,
  };
}

export function SetIsChatFullScreen(cond) {
  return {
    type: SET_IS_CHAT_FULL_SCREEN,
    cond,
  };
}

export function SetSessionAvailable(cond) {
  return {
    type: SET_SESSION_AVAILABLE,
    cond,
  };
}

export function SetSessionStarted(cond) {
  return {
    type: SET_SESSION_STARTED,
    cond,
  };
}

export function SetShowSenderComponent(cond) {
  return {
    type: SET_SHOW_SENDER_COMPONENT,
    cond,
  };
}

export function SetRecentMessage(val) {
  return {
    type: SET_RECENT_MESSAGE,
    val,
  };
}

export function AddUserMessage(text, id) {
  return {
    type: ADD_NEW_USER_MESSAGE,
    text,
    id,
  };
}

export function AddResponseMessage(text, id) {
  return {
    type: ADD_NEW_RESPONSE_MESSAGE,
    text,
    id,
  };
}

export function ToggleMsgLoader() {
  return {
    type: TOGGLE_MESSAGE_LOADER,
  };
}

export function AddLinkSnippet(link, id) {
  return {
    type: ADD_NEW_LINK_SNIPPET,
    link,
    id,
  };
}
export function RenderHistoryComponent(component, props, showAvatar, id) {
  return {
    type: ADD_HISTORY_COMPONENT,
    component,
    props,
    showAvatar,
    id,
  };
}
export function RenderCustomComponent(component, props, showAvatar, id) {
  return {
    type: ADD_COMPONENT_MESSAGE,
    component,
    props,
    showAvatar,
    id,
  };
}

export function DropMessages() {
  return {
    type: DROP_MESSAGES,
  };
}

export function HideAvatar(index) {
  return {
    type: HIDE_AVATAR,
    index,
  };
}

export function DeleteMessages(count, id) {
  return {
    type: DELETE_MESSAGES,
    count,
    id,
  };
}

export function DeleteLastMessage() {
  return {
    type: DELETE_LAST_MESSAGE,
  };
}

export function SetQuickButtons(buttons) {
  return {
    type: SET_QUICK_BUTTONS,
    buttons,
  };
}

export function SetBadgeCount(count) {
  return {
    type: SET_BADGE_COUNT,
    count,
  };
}

export function ResetMessages(value) {
  return {
    type: RESET_MESSAGES,
    value,
  };
}

export function MarkAllMessagesRead() {
  return {
    type: MARK_ALL_READ,
  };
}

export function OpenFullscreenPreview(payload) {
  return {
    type: OPEN_FULLSCREEN_PREVIEW,
    payload,
  };
}

export function CloseFullscreenPreview() {
  return {
    type: CLOSE_FULLSCREEN_PREVIEW,
  };
}
